import { render, staticRenderFns } from "./ReferralRecord.vue?vue&type=template&id=95f0339c&scoped=true&"
import script from "./ReferralRecord.vue?vue&type=script&lang=js&"
export * from "./ReferralRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReferralRecord.vue?vue&type=style&index=0&id=95f0339c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f0339c",
  null
  
)

export default component.exports